<p-inputNumber
  #pInputNumber
  mode="decimal"
  [format]="false"
  [id]="ctrlUUID"
  [inputId]="ctrlUUID"
  [placeholder]="formField.placeholder || ''"
  [formControl]="ctrl"
  [min]="formField.min === undefined ? undefined : formField.min"
  [max]="formField.max === undefined ? undefined : formField.max"
  [minlength]="formField.minLength === undefined ? null : formField.minLength"
  [maxlength]="formField.maxLength === undefined ? null : formField.maxLength"
  [autocomplete]="ctrlUUID"
/>
